/* eslint-disable jsx-a11y/alt-text */
import clsx from "clsx";
import React from "react";

type AvatarProps = {} & React.ImgHTMLAttributes<HTMLImageElement>;
const Avatar = (props: AvatarProps) => {
    const {
        className,
        src = "https://storage.googleapis.com/heysynth_files/synth_webapp/defaultUser_n48r5i.svg",
        ...rest
    } = props;
    return (
        <img
            className={clsx(
                "w-8 h-8 rounded-full flex justify-center items-center object-cover",
                props.className
            )}
            src={src}
            onError={(e) => {
                e.currentTarget.src =
                    "https://storage.googleapis.com/heysynth_files/synth_webapp/defaultUser_n48r5i.svg";
            }}
            {...rest}
        />
    );
};

export default Avatar;
